import React from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect } from "../../../../Components/Forms/renders";
class AlertProfileform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
  }

  render() {
    const { handleSubmit, soortValue } = this.props;

    return (
      <div className="box box-default">
        <form onSubmit={handleSubmit}>
          <div className="box-body">
            <div className="row">
              <div className="col-6">
                <Field name="naam" type="input" validate={[required()]} component={renderField} label="Naam connectie" />
                <Field
                  className="form"
                  name="soort"
                  validate={required({ msg: "Type item is verplicht" })}
                  label="Kies een soort connection"
                  component={renderselect}
                  options={{
                    Instagram: "Instagram",
                    Facebook: "Facebook",
                    GoogleBusiness: "Google Business",
                    FeedFactory: "FeedFactory",
                    VisitVeluwe: "Visit Veluwe",
                    Web: "Web",
                    API: "API",
                  }}
                />

                {/* Show Client ID and Secret for OAuth-based connections */}
                {(soortValue === 'Instagram' || soortValue === 'Facebook' || soortValue === 'GoogleBusiness') && (
                  <>
                    <Field name="client_id" type="input" validate={[required()]} component={renderField} label="Client ID" />
                    <Field name="client_secret" type="input" validate={[required()]} component={renderField} label="Client Secret" />
                  </>
                )}

                {/* FeedFactory specific fields */}
                {soortValue === 'FeedFactory' && (
                  <>
                    <Field name="api_key" type="input" validate={[required()]} component={renderField} label="API Key" />
                    <Field name="api_url" type="input" validate={[required()]} component={renderField} label="API URL" placeholder="https://api.feedfactory.nl" />
                    <Field name="organization_id" type="input" component={renderField} label="Organization ID" />
                  </>
                )}

                {/* Visit Veluwe specific fields */}
                {soortValue === 'VisitVeluwe' && (
                  <>
                    <Field name="api_key" type="input" validate={[required()]} component={renderField} label="API Key" />
                    <Field name="api_url" type="input" validate={[required()]} component={renderField} label="API URL" />
                    <Field name="partner_id" type="input" component={renderField} label="Partner ID" />
                  </>
                )}

                {/* Generic Web/API fields */}
                {(soortValue === 'Web' || soortValue === 'API') && (
                  <>
                    <Field name="url" type="input" validate={[required()]} component={renderField} label="URL" />
                    <Field name="api_key" type="input" component={renderField} label="API Key (optioneel)" />
                    <Field name="username" type="input" component={renderField} label="Username (optioneel)" />
                    <Field name="password" type="password" component={renderField} label="Password (optioneel)" />
                  </>
                )}

                {/* Test URL field - available for all connection types */}
                <Field
                  name="test_url"
                  type="input"
                  component={renderField}
                  label="Test URL (optioneel)"
                  placeholder="https://example.com/test"
                />

              </div>
            </div>
            <div className="pull-left submit">
              <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Aanmaken" />
            </div>
          </div>
        </form>
      </div>
    );
  }
}
AlertProfileform = reduxForm({
  form: "alertprofileinsert", // a unique identifier for this form
})(AlertProfileform);

// Selector to get the current value of 'soort' field
const selector = formValueSelector("alertprofileinsert");

// You have to connect() to any reducers that you wish to connect to yourself
AlertProfileform = connect((state) => {
  const soortValue = selector(state, "soort");
  return {
    soortValue
  };
})(AlertProfileform);

export default AlertProfileform;
